import { cn } from "@core/utils/cn";

interface SkeletonProps {
  className?: string;
  width?: string;
  height?: string;
  rounded?: "sm" | "md" | "lg" | "full";
}

const roundedMap = {
  sm: "rounded-sm",
  md: "rounded-md",
  lg: "rounded-lg",
  full: "rounded-full",
};

const Skeleton = ({
  className,
  width,
  height,
  rounded = "md",
}: SkeletonProps) => {
  return (
    <div
      className={cn(
        "animate-pulse bg-neutral-200",
        roundedMap[rounded],
        className,
      )}
      style={{
        width: width,
        height: height ?? "1rem",
      }}
    />
  );
};

export default Skeleton;
